export enum DiscountType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  LOYALTY = 'LOYALTY'
}

export enum DiscountFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SCHEDULED = 'SCHEDULED'
}
